import { FUtil } from '@freelog/tools-lib';
import { fetchEventSource } from '@microsoft/fetch-event-source';

type MetaInfoArray_Type = {
  insertMode: 1 | 2;
  key: string;
  name: string;
  remark: string;
  value: number | string | null;
  valueDisplay: string;
  valueUnit: string;
}[];

interface IParseResult {
  sha1: string;
  // state: 'success' | 'fail' | 'nonentity';
  metaAnalyzeStatus: 0 | 1 | 2 | 3; // 0:未解析 1:解析中 2:解析成功 3:解析失败
  fileSize: number;
  metaInfoArray: MetaInfoArray_Type;
}

export class PropertyParser {
  public static parse(
    params: {
      sha1s: string[];
      resourceTypeCode: string;
    },
    onMessage: (data: IParseResult) => void,
    onEnd: () => void,
  ): () => void {
    // debugger;
    const eventSource = new EventSource(
      FUtil.Format.completeUrlByDomain('api') +
        `/v2/storages/files/listSSE/info?sha1=${params.sha1s.join(',')}&resourceTypeCode=${
          params.resourceTypeCode
        }`,
      {
        withCredentials: true,
      },
    );

    eventSource.addEventListener('message', function (event) {
      const data: IParseResult = JSON.parse(event.data);
      onMessage(data);
    });

    eventSource.onopen = function (event) {
      // console.log('Connection to server opened.');
    };
    // 监听错误事件
    eventSource.onerror = function (event) {
      // console.log(event, '&&&&&&&&&&&&&&&&&&&&&&&&&&&&');
      // console.error('EventSource failed.');
      eventSource.close();
      onEnd();
    };

    return eventSource.close;
  }

  public static parsePromise(params: {
    sha1s: string[];
    resourceTypeCode: string;
  }): Promise<IParseResult[]> {
    return new Promise((resolve) => {
      const result: IParseResult[] = [];
      this.parse(
        {
          sha1s: params.sha1s,
          resourceTypeCode: params.resourceTypeCode,
        },
        (data) => {
          result.push(data);
          // debugger;
        },
        () => {
          resolve(result);
          // debugger;
        },
      );
    });
  }
}
